import React, { lazy, Suspense } from "react";
import {
    BrowserRouter as Router,
    Route,
    Routes,
    Navigate,
} from "react-router-dom";
import checkAuth from "../../src/app/auth";
import Coupons from "../components/pages/Coupons";
import AddCoupons from "../components/pages/AddCoupons";
import Transaction from "../components/pages/transaction/Transaction";
import BookingDetail from "../components/pages/transaction/BookingDetail";
import TourAndPackages from "../components/package/TourAndPackages";
import PackageList from "../components/package/PackageList";
import ManageAirportDestinationsList from "../components/airportDestinations/ManageAirportDestinationsList";
import AddManageAirportDestinations from "../components/airportDestinations/AddManageAirportDestinations";
import PopularAirPortDestination from "../components/airportDestinations/PopularAirPortDestination";
import AddPopularAirPortDestination from "../components/airportDestinations/AddPopularAirPortDestination";
import CategoryList from "../components/package/CategoryList";
import AddCategory from "../components/package/AddCategory";
import Adddestination from "../components/package/Adddestination";
import DestinationsList from "../components/package/DestinationsList";
import HolidayBookings from "../layouts/HolidayBookings";
import FlightBookings from "../components/pages/transaction/Booking";
import PriceList from "../components/pages/PriceList";
import HotelBookings from "../layouts/HotelBooking";
import BookingHotelDetail from "../components/pages/transaction/BookingHotelDetail";
import HotelPriceList from "../components/pages/HotelPriceList";
import PriceFareRuleList from "../components/pricefarerule/PriceFareRuleList";
import AddPriceFareRuleList from "../components/pricefarerule/AddPriceFareRuleList";
import ManagerLayout from "../layouts/ManagerLayout";
import BusinessAnalystLayout from "./BusinessAnalystLayout";
import AddFeedback from "../components/package/AddFeedback";
import Feedbacks from "../components/package/Feedbacks";

const Dashboard = lazy(() => import("../layouts/Dashboard"));

function BusinessAnalystRouter() {

    return (
        <Router>
            <Routes>
                <Route element={<BusinessAnalystLayout />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/coupons" element={<Coupons />} />
                    <Route path="/add-coupons" element={<AddCoupons />} />
                    <Route path="/edit-coupons/:id" element={<AddCoupons />} />
                    <Route path="transaction" element={<Transaction />} />
                    <Route path="/flight-bookings" element={<FlightBookings />} />
                    <Route path="/booking-detail/:id" element={<BookingDetail />} />
                    <Route path="/hotel-booking-details/:id" element={<BookingHotelDetail />} />
                    <Route path="/add-tour-and-packages" element={<TourAndPackages />} />
                    <Route path="/manage-airport-destinations-list" element={<ManageAirportDestinationsList />} />
                    <Route path="/add-manage-airport-destinations" element={<AddManageAirportDestinations />} />
                    <Route path="/edit-manage-airport-destinations/:id" element={<AddManageAirportDestinations />} />
                    <Route path="/edit-package/:id" element={<TourAndPackages />} />
                    <Route path="/package-list" element={<PackageList />} />
                    <Route path="/category-list" element={<CategoryList />} />
                    <Route path="/add-category" element={<AddCategory />} />
                    <Route path="/edit-category/:id" element={<AddCategory />} />
                    <Route path="/destination-list" element={<DestinationsList />} />
                    <Route path="/add-destination" element={<Adddestination />} />
                    <Route path="/edit-destination/:id" element={<Adddestination />} />
                    <Route path="/hotel-bookings" element={<HotelBookings />} />
                    <Route path="/holiday-bookings" element={<HolidayBookings />} />
                    <Route path="/price-fare-rule" element={<PriceFareRuleList />} />
                    <Route path="/add-price-fare-rule" element={<AddPriceFareRuleList />} />
                    <Route path="/edit-price-fare-rule/:id" element={<AddPriceFareRuleList />} />
                    <Route path="/price-list" element={<PriceList />} />
                    <Route path="/popular-airPort-destination" element={<PopularAirPortDestination />} />
                    <Route path="/add-popular-airPort-destination" element={<AddPopularAirPortDestination />} />
                    <Route path="/edit-popular-airPort-destination/:id" element={<AddPopularAirPortDestination />} />
                    <Route path="/add-feedback" element={<AddFeedback />} />
                    <Route path="/edit-feedback/:id" element={<AddFeedback />} />
                    <Route path="/feedbacks" element={<Feedbacks />} />
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/hotel-price-list" element={<HotelPriceList />} />
                </Route>
            </Routes>
        </Router>
    );
}

export default BusinessAnalystRouter;
